<template>
  <v-card class="pa-5" outlined>
    <v-alert
      v-if="$route.query.codeVerified"
      type="success"
      dense
      text
      class="pa-2 my-2"
      >Your phone number has been verified.</v-alert
    >
    <v-card-title>
      <h1>Welcome Back!</h1>
    </v-card-title>
    <v-card-text>
      <v-form
        v-model="isFormValid"
        :disabled="isLoading"
        @submit.prevent="validateAccount"
      >
        <div class="text-h6"
          >It looks like this is your first time signing in since we enhanced
          our security.
          <br />
          We'll have to confirm your email and then setup a password.
        </div>

        <v-text-field
          v-model="phone"
          class="phone-input"
          color="deep-orange"
          label="Phone Number"
          large
          readonly
          disabled
        />
        <v-text-field
          v-model="email"
          class="phone-input"
          color="deep-orange"
          autofocus
          label="Re-enter Your Email"
          :placeholder="$route.params.emailHint || null"
          large
          :rules="[confirmEmailRequiredRule, emailRule]"
        />

        <transition name="fade" mode="out-in">
          <div v-if="error" class="error--text title my-4">{{ error }}</div>
        </transition>
        <v-btn
          color="blue darken-2 white--text"
          :disabled="!isFormValid"
          depressed
          x-large
          type="submit"
          :loading="isLoading"
          block
          >Confirm Email and Phone</v-btn
        >
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import RouteNames from '@/constants/RouteNames'
export default {
  name: 'LegacyValidationEmailCard',
  components: {},
  data() {
    return {
      isFormValid: false,
      isLoading: false,
      phone: '',
      email: '',
      error: null,
      confirmEmailRequiredRule: (v) =>
        !!v.trim() ||
        'Please confirm the email associated with your phone number.',
      emailRule: (email) => {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email) || 'Please enter a valid email'
      },
    }
  },
  created() {
    if (this.$route.params.phone) {
      if (this.$route.params.phone.length < 10) {
        this.$router.push({ name: RouteNames.Customer.LOGIN_WITH_PHONE })
      }
      this.phone = this.$route.params.phone.length
        ? this.$route.params.phone
        : ''
    }
  },
  computed: {
    sanitizedPhone() {
      return this.phone.replace(/\D/g, '')
    }, // sanitizedPhone
  },
  methods: {
    ...mapActions('snackbars', ['setAccountCreatedSnackbar']),
    ...mapActions('customer', ['validateLegacyCustomer']),

    async validateAccount() {
      this.isLoading = true
      this.error = null
      if (!this.isFormValid) {
        return false
      }
      try {
        // Validate this Email and Phone are a match
        let isValid = await this.validateLegacyCustomer({
          phone: this.sanitizedPhone,
          email: this.email,
        })
        if (!isValid) {
          // - if this is not a valid pair
          this.error = 'The email you entered did not match our records.'
        } else {
          // - if YES : good match
          // -- open password field
          this.$emit('validated', {
            phone: this.sanitizedPhone,
            email: this.email,
          })
        }
      } catch (error) {
        throw Error(error)
      } finally {
        this.isLoading = false
      }
    }, // validateAccount
  }, // methods
}
</script>
